import { createPromise } from '@wix/thunderbolt-commons'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import { ViewerManagerByRefApiSideEffects, byRefInfoState, IByRefResolvingDone } from './types'
import { IDataRequirementsChecker } from '@wix/thunderbolt-symbols'

export const byRefResolvingDoneChecker = withDependencies(
	[],
	(): IModelUpdatesHandlersImplementor<ViewerManagerByRefApiSideEffects> &
		IDataRequirementsChecker &
		IByRefResolvingDone => {
		const state: byRefInfoState = {
			byRefResolvingDonePromise: Promise.resolve(),
			byRefResolvingDonePromiseResolver: () => {},
		}

		return {
			featureName: name,
			handlers: {
				onByRefResolvingDoneChange: (newByRefResolveValue) => {
					if (newByRefResolveValue) {
						state.byRefResolvingDonePromiseResolver()
					} else {
						const { resolver, promise } = createPromise()
						state.byRefResolvingDonePromise = promise
						state.byRefResolvingDonePromiseResolver = resolver
					}
				},
			},
			pendingRequirements: () => {
				return state.byRefResolvingDonePromise
			},
			isByRefResolvingDone: () => {
				return state.byRefResolvingDonePromise
			},
		}
	}
)
